module.exports = __webpack_public_path__ + "img/num_1.8869487f.png";